import { throwNetworkError } from '@twnel/web-components';
import { updateAgents } from '../reducer/agents';

export { updateAgents };

export const fetchAgents = (companyId) => async (dispatch, getState, getContext) => {
  const { api } = getContext();
  const companyMask = { id: companyId };
  const agents = await api.agents.get(companyMask)
    .catch(throwNetworkError);
  dispatch(updateAgents({ companyId, update: agents }));
  return agents;
};
